import { Table } from 'antd';
import { useTenants } from 'providers/Tenant/TenantProvider';
import React from 'react';
import { Link } from 'react-router-dom';
import paths from 'assets/routes/paths';

const TenantsTable = () => {
  const { loading, data } = useTenants();
  return (
    <Table
      rowKey="id"
      loading={loading}
      dataSource={data}
      columns={[
        {
          key: 'id',
          dataIndex: 'id',
          title: 'N°',
          render: (value) => <Link to={paths.tenants.detail(value)}>{value}</Link>,
        },
        {
          key: 'organization',
          dataIndex: 'organization',
          title: 'Organización',
          render: (value) => <span className="uppercase">{value}</span>,
        },
        {
          key: 'logo',
          dataIndex: 'logo',
          title: 'Logo',
          render: (value) => (
            <span className="uppercase">{value ? 'Sí' : 'No'}</span>
          ),
        },
        {
          key: 'createdAt',
          dataIndex: 'createdAt',
          title: 'Fecha de registro',
        },
      ]}
    />
  );
};

export default TenantsTable;
